import UserRanksCard from "~/components/sider/UserRanksCard";
import NewPostCard from "~/components/sider/NewPostCard";

export default () => {
  return (
    <div>
      <NewPostCard simpleMode />
      <UserRanksCard />
    </div>
  );
};
